/*
 * @Description: 成本/收入数据 api
 * @Date: 2020-07-23 13:49:00
 * @LastEditTime: 2020-10-18 13:00:45
 */ 

import request from '@/utils/request.js'

export function inputList(params) {
    return request({
        url: `/api/channel/input`,
        method: 'get',
        params
    })
}

export function inputCreate(data) {
    return request({
        url: `/api/channel/input/`,
        method: 'post',
        data
    })
}

export function inputDelete(data) {
    return request({
        url: `/api/channel/input/${data.id}/`,
        method: 'delete',
        data
    })
}

export function outputList(params) {
    return request({
        url: `/api/channel/output`,
        method: 'get',
        params
    })
}

export function outputCreate(data) {
    return request({
        url: `/api/channel/output/`,
        method: 'post',
        data
    })
}

export function outputDelete(data) {
    return request({
        url: `/api/channel/output/${data.id}/`,
        method: 'delete',
        data
    })
}

export function reportAppList(params) {
    return request({
        url: '/api/dashboard/data/app/',
        method: 'get',
        params
    })
}

export function reportProList(params) {
    return request({
        url: '/api/dashboard/data/project/',
        method: 'get',
        params
    })
}

export function newList(data) {
    return request({
        url: '/api/dashboard/s/',
        method: 'post',
        data
    })
}

export function retainedList(data) {
    return request({
        url: '/api/dashboard/r_t/',
        method: 'post',
        data
    })
}